import { pipe } from 'ramda';
import { useCallback, useMemo } from 'react';
import {
  useProjectAsRBACResource,
  useWithAccess,
} from 'hooks/rbac/useWithAccess';
import { readonly_fields } from '../../organisms/tasks/utils';

export const useGetReadonlyFieldsForProjectTaskList = ({
  projectId,
}: {
  projectId: number;
}) => {
  const project = useProjectAsRBACResource(projectId);
  const { hasAccessToResource } = useWithAccess();
  const projectPhaseAsReadOnlyIfNoAccess = useCallback(
    (readOnlyFields) =>
      hasAccessToResource({
        rule: 'TASK_UPDATE_PHASE:WRITE',
        resourceData: project,
      })
        ? readOnlyFields
        : readOnlyFields.concat(['projectPhaseId']),
    [hasAccessToResource, project],
  );
  const assigneeAsReadOnlyIfNoAccess = useCallback(
    (readOnlyFields) =>
      hasAccessToResource({
        rule: 'TASK_ASSIGNEE:WRITE',
        resourceData: project,
      })
        ? readOnlyFields
        : readOnlyFields.concat(['assignee']),
    [hasAccessToResource, project],
  );

  return useMemo(
    () =>
      pipe(
        assigneeAsReadOnlyIfNoAccess,
        projectPhaseAsReadOnlyIfNoAccess,
      )(readonly_fields),
    [assigneeAsReadOnlyIfNoAccess, projectPhaseAsReadOnlyIfNoAccess],
  );
};
